import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { RestaurantServiceService } from '../restaurant-service.service';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GenericServiceService } from '../../services/generic-service.service';
import { find, get, pull } from 'lodash';

@Component({
  selector: 'app-add-restaurant',
  templateUrl: './add-restaurant.component.html',
  styleUrls: ['./add-restaurant.component.scss'],

})
export class AddRestaurantComponent implements OnInit {
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  model: any = {};
  alert = false;
  enumarray: any = [];
  page: number;
  countryList: any = [];
  tagList: any = [];
  dataModel: any = [];
  cityList: any = [];
  restTypeModel: any = [];
  restTypeId: any = [];
  tagsId: any = [];

  listOfRestaurantsType: any = [];
  panelColor = new FormControl('red');

  configRestaurantType = {
    displayKey: 'Name', // if objects array passed which key to be displayed defaults to description
    search: true,
    limitTo: 3
  };


  config = {
    displayKey: 'Name',
    search: true,
    limitTo: 3
  };
  @ViewChild('tagInput', {static : true}) tagInputRef: ElementRef;
  tags: string[] = [];
  form: FormGroup;
  constructor(
    private restaurantService: RestaurantServiceService,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private genericService: GenericServiceService,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.getAllTags();
    this.getAllRestaurnatType();

    this.getAllCountries();
    this.form = this.fb.group({
      tag: [undefined],
    });
  }
  focusTagInput(): void {
    this.tagInputRef.nativeElement.focus();
  }
  onKeyUp(event: KeyboardEvent): void {
    debugger;
    const inputValue: string = this.form.controls.tag.value;
    if (event.code === 'Backspace' && !inputValue) {
      this.removeTag();
      return;
    } else {
      if (event.code === 'Comma' || event.code === 'Space' || event.code === 'Enter' ) {
        this.addTag(inputValue);
        this.form.controls.tag.setValue('');
      }
    }
  }
  addTag(tag: string): void {
    debugger;
    if (tag[tag.length - 1] === ',' || tag[tag.length - 1] === ' ') {
      tag = tag.slice(0, -1);
    }
    if (tag.length > 0 && !find(this.tags, tag)) {
      this.tags.push(tag);
    }
  }

  removeTag(tag?: string): void {
    if (!!tag) {
      pull(this.tags, tag);
    } else {
      this.tags.splice(-1);
    }
  }
  getAllCountries() {
    this.genericService.getAllCountries().subscribe(Response => {
      this.countryList = Response;
    });
  }
  getAllTags() {
    this.genericService.getAllTags().subscribe(Response => {
      this.tagList = Response;
      console.log('taglist', this.tagList);
    });
  }
  city(id) {
    this.genericService.getCitWithId(id).subscribe(Response => {
      this.cityList = Response;
    });
  }


  getAllRestaurnatType() {
    this.restaurantService.getAllRestaurantsType().subscribe(Response => {
      this.listOfRestaurantsType = Response;
      console.log(this.listOfRestaurantsType);

    });
  }

  onSubmit() {
    debugger;
    console.log(this.restTypeModel);
    console.log(this.dataModel);
    this.model.Longitude = 74.329376;
    this.model.Latitude = 31.582045;
    for (let i = 0; i < this.dataModel.length; i++) {
      this.tagsId.push(this.dataModel[i]['Id']);
    }
    this.model.RestaurantTagId= this.tagsId;

    this.model.IsApproved = false;
    for (let i = 0; i < this.restTypeModel.length; i++) {
      this.restTypeId.push(this.restTypeModel[i]['Id']);
    }
    this.model.RestaurantTypeId = this.restTypeId;
    this.restaurantService.CreateResturant(this.model).subscribe((Data: any) => {
      if (!Data.id) {
        this.toastr.success(Data.Message);
        this.alert = true;
        this.router.navigateByUrl('/restaurant');
      }
    }, error => {
      this.toastr.error(error.error.Message);
    });
  }
}
